function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M487.436,330.191c-6.191-14.622-21.111-24.835-36.283-24.835c-9.703,0-18.483,4.044-25.334,11.629l-4.91,5.343V68.607 c0-20.477-16.658-37.135-37.134-37.135H318.79V10c0-5.522-4.478-10-10-10H133.892c-5.522,0-10,4.478-10,10v21.473H58.906 c-20.476,0-37.134,16.658-37.134,37.135v406.26C21.772,495.343,38.43,512,58.906,512h324.869 c20.476,0,37.134-16.657,37.134-37.133V431.9l59.418-64.655C490.243,356.94,492.902,343.099,487.436,330.191z M143.892,20H298.79 v11.473H143.892V20z M383.775,492H58.906c-9.447,0-17.134-7.685-17.134-17.133V68.607c0-9.448,7.687-17.135,17.134-17.135h324.869 c9.447,0,17.134,7.687,17.134,17.135V344.09l-19.369,21.077V89.295c0-5.522-4.478-10-10-10H71.141c-5.523,0-10,4.478-10,10V454.18 c0,5.523,4.477,10,10,10h236.207l14.522,11.322c10.518,8.2,20.327,12.188,29.985,12.186c12.132,0,23.328-6.034,35.235-18.99 l13.817-15.035v21.204h0.002C400.909,484.314,393.223,492,383.775,492z M283.49,444.18H81.141V99.295H361.54V386.93 l-13.645,14.848l-10.792-8.413c-11.827-12.28-23.54-14.883-31.335-14.883c-14.557,0-27.244,8.997-32.323,22.92 C268.243,415.663,272.01,431.133,283.49,444.18z M465.866,353.43c-0.062,0.064-0.122,0.127-0.183,0.192l-93.318,101.543 c-10.316,11.226-16.646,12.523-20.509,12.523c-5.032,0-10.818-2.604-17.688-7.96l-30.784-24.001 c-10.13-8.584-14.297-18.845-11.149-27.473c2.166-5.937,7.479-9.772,13.534-9.772c5.694,0,11.682,3.168,17.316,9.162 c0.352,0.374,0.732,0.721,1.138,1.037l18.647,14.539c4.107,3.202,9.986,2.715,13.512-1.12l84.222-91.645 c3.056-3.383,6.605-5.099,10.55-5.099c7.136,0,14.816,5.432,17.866,12.633C471.402,343.617,470.341,348.812,465.866,353.43z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M316.251,140.346H170.383c-5.522,0-10,4.478-10,10c0,5.522,4.478,10,10,10h145.868c5.523,0,10-4.478,10-10 C326.251,144.824,321.774,140.346,316.251,140.346z"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M140.43,140.346h-1.756c-5.523,0-10,4.478-10,10c0,5.522,4.477,10,10,10h1.756c5.522,0,10-4.478,10-10 C150.43,144.823,145.953,140.346,140.43,140.346z"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M316.251,205.02H193.883c-5.522,0-10,4.477-10,10c0,5.522,4.478,10,10,10H316.25c5.523,0,10-4.478,10-10 C326.251,209.497,321.773,205.02,316.251,205.02z"
})));

var _ref6 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M316.251,269.904H174.383c-5.522,0-10,4.478-10,10c0,5.522,4.478,10,10,10H316.25c5.523,0,10.001-4.477,10.001-10 C326.251,274.382,321.774,269.904,316.251,269.904z"
})));

var _ref7 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M140.43,269.904h-1.756c-5.523,0-10,4.478-10,10c0,5.522,4.477,10,10,10h1.756c5.522,0,10-4.478,10-10 C150.43,274.382,145.953,269.904,140.43,269.904z"
})));

var _ref8 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M316.251,334.578H193.883c-5.522,0-10,4.478-10,10c0,5.522,4.478,10,10,10H316.25c5.523,0,10.001-4.477,10.001-10 C326.251,339.056,321.774,334.578,316.251,334.578z"
})));

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var _ref18 =
/*#__PURE__*/
React.createElement("g", null);

var _ref19 =
/*#__PURE__*/
React.createElement("g", null);

var _ref20 =
/*#__PURE__*/
React.createElement("g", null);

var _ref21 =
/*#__PURE__*/
React.createElement("g", null);

var _ref22 =
/*#__PURE__*/
React.createElement("g", null);

var _ref23 =
/*#__PURE__*/
React.createElement("g", null);

var SvgLista = function SvgLista(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLista, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lista.e711031e.svg";
export { ForwardRef as ReactComponent };